import purifyHtml from '@propertypal/shared/src/services/dompurify';
import React from 'react';
import { Content } from './RichText.style';

interface RichTextProps {
  html?: string | null;
  className?: string;
  testId?: string;
}
const RichText: React.FC<RichTextProps> = ({ html, className, testId }) => {
  if (!html || (html && html.replace(/\s/g, '')) === '') return null;

  return (
    <Content
      data-testid={testId || 'rich-text'}
      className={className}
      dangerouslySetInnerHTML={{ __html: purifyHtml(html) }}
    />
  );
};

export default RichText;
